import {
  EMPTY_MILEAGE_CLAIM_DRAFT,
  type MileageClaimDraft,
} from "@nmible-ltd/claims";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

/**
 * In-progress mileage claim wizard state. Lives in Redux (not page `useState`)
 * so it survives a remount of the route subtree when the participant navigates
 * back to the flow. Blacklisted from redux-persist (see `store/store.ts`): kept
 * in memory only and cleared at the flow boundaries by `useClaimDraftCleanup`
 * and the new-claim menu.
 */
export type MileageClaimDraftState = MileageClaimDraft;

export const mileageClaimDraftSlice = createSlice({
  name: "mileageClaimDraft",
  initialState: EMPTY_MILEAGE_CLAIM_DRAFT,
  selectors: {
    selectMileageClaimDraft: (state) => state,
  },
  reducers: {
    patchMileageClaimDraft: (
      state,
      action: PayloadAction<Partial<MileageClaimDraftState>>
    ) => {
      Object.assign(state, action.payload);
    },
    resetMileageClaimDraft: () => EMPTY_MILEAGE_CLAIM_DRAFT,
  },
});

export const { selectMileageClaimDraft } = mileageClaimDraftSlice.selectors;

export const { patchMileageClaimDraft, resetMileageClaimDraft } =
  mileageClaimDraftSlice.actions;
